import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";
import { FC } from "react";
import { PageStoryblok } from "@/types/sb-component-types";
interface IPageProps {
  blok: PageStoryblok;
}
const Page: FC<IPageProps> = ({
  blok
}) => <div {...storyblokEditable(blok)} data-sentry-component="Page" data-sentry-source-file="Page.tsx">
    {blok.body?.map(nestedBlok => <StoryblokComponent key={nestedBlok._uid} blok={nestedBlok} />)}
  </div>;
export default Page;